import React, { useState } from "react";

const Footer = () => {
  const [bgStyle] = useState({ backgroundColor: "#f5f5f5" });

  return (
    <footer style={bgStyle} className="mt-auto py-3 text-center">
      {/* <strong> &copy; 2019 </strong>*/}
      <i className="fas fa-code"></i> with <i className="fas fa-heart"></i> by{" "}
      <a
        className="badge bg-dark text-white text-decoration-none"
        rel="noopener"
        href="https://github.com/enzo88"
        aria-label="My GitHub"
      >
        Vincenzo Pimpinella
      </a>{" "}
      using <i className="fab fa-react"></i>
    </footer>
  );
};

export default Footer;
